module.exports = __webpack_public_path__ + "img/CB1-On-1.09f5f63c.gif";